import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import {
  type ContractDocumentDataProps,
  contractDocumentDataSchema,
} from "./ContractDocument.schema";
import { ContractDocument } from "./components/ContractDocument";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "contract-document": {
      props: ContractDocumentDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-contract-document": HTMLElement;
  }
}

export function RWCContractDocument({
  projectId,
  contractId,
  brand,
}: ContractDocumentDataProps): JSX.Element {
  return (
    <ContractDocument
      projectId={projectId}
      contractId={contractId}
      brand={brand}
    />
  );
}

componentManager.register(
  rwc("contract-document", {
    component: RWCContractDocument,
    dataSchema: contractDocumentDataSchema,
  }),
);
